module.exports = __webpack_public_path__ + "img/placeholder-image.12d0fc49.png";